export default "__VITE_ASSET__Dys99tFj__"